import React, { useState } from "react";
import styles from "./styles/Customers.module.css";
import config from "../../../config";
import { formatTime } from "../../../Utils/formatTime";
import { formatDate } from "../../../Utils/formatDate";
import { handleAdminIssues } from "./handleAdminIssues";
import TableFilter from "../../User/Assets/TableFilter";
import { ReferralTable } from "../../User/My Account/referralTable";
import dayjs from "dayjs";
import { useMemo } from "react";

import { UserData } from "../../../Context/DataContext";
import { useEmployeeAuth } from "../AdminProvider";
import { formatPhone } from "../../../Utils/formatPhone";
import { Button, Checkbox, Modal, message } from "antd";
const base_url = config.base_url;
function Customers() {
  const [showCodes, setShowCodes] = useState(false);
  const [otp_code, setOTP] = useState();
  const [email_otp_code, setEmailOTP] = useState();
  const [userid, setUserID] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [inputError, setInputError] = useState();
  const [data, setData] = useState(undefined);
  const [referral, setReferral] = useState();
  const [tableData, setTableData] = useState([]);
  const [filter, setFilter] = useState();
  const [beneficiaryFilter, setBeneficiaryFilter] = useState();
  const [beneficiariesData, setBeneficiariesData] = useState([]);
  const [ben, setBen] = useState();
  const [userIsAdmin, setUserIsAdmin] = useState(useEmployeeAuth().isAdmin);
  const [openDeleteUserModal, setOpenDeleteUserModal] = useState(false);
  const [openCancelUserModal, setOpenCancelUserModal] = useState(false);
  const [cancelSubCheckbox, setCancelSubCheckbox] = useState(false);
  const [deleteUserCheckbox, setDeleteUserCheckbox] = useState(false);
  const [issues, setIssues] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const success = (type, text) => {
    messageApi.open({
      type: type,
      content: text,
    });
  };
  const sendCode = () => {
    setInputError();
    fetch(base_url + "admin/customers/sendCode", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `user_id=${userid}`,
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.error) setInputError(data.error);
        else {
          console.log(data);
          setInputError(data.result);
          setTimeout(() => {
            setInputError();
          }, 4000);
        }
      })
      .catch((err) => {
        setInputError(err);
      });
  };
  const sendCodeForEmail = () => {
    setInputError();
    fetch(base_url + "admin/customers/sendCode", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `customer_email=${userEmail}`,
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.error) setInputError(data.error);
        else {
          console.log(data);
          setInputError(data.result);
          setTimeout(() => {
            setInputError();
          }, 4000);
        }
      })
      .catch((err) => {
        setInputError(err);
      });
  };
  const verifyCustomer = () => {
    if (userid.length === 0) {
      return;
    }
    fetch(base_url + "admin/customers/verify", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `user_id=${userid}&otp_code=${""}`,
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        console.log(data);

        setCancelSubCheckbox(false);
        setDeleteUserCheckbox(false);
        if (data.error) {
          setInputError(data.error);
          setData(undefined);
          setTableData([]);
          setBeneficiariesData([]);
          setIssues([]);
          return;
        } else {
          setIssues(handleAdminIssues(data.customerInfo.issues));
          setData(data);
        }
        setInputError(null);
        setTableData(data.referralEvents.referrals);
        setBeneficiariesData(data.beneficiaryData);
      })
      .catch((err) => {
        setInputError(err);
        setCancelSubCheckbox(false);
        setDeleteUserCheckbox(false);
      });
  };
  const verifyCustomerEmail = () => {
    if (userEmail.length === 0) {
      return;
    }
    fetch(base_url + "admin/customers/verify", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `customer_email=${userEmail}&otp_code=${email_otp_code}`,
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setCancelSubCheckbox(false);
        setDeleteUserCheckbox(false);
        console.log(data);

        if (data.error) {
          setInputError(data.error);
          setData(undefined);
          setTableData([]);
          setBeneficiariesData([]);
          setIssues([]);

          return;
        } else {
          setData(data);
          setIssues(handleAdminIssues(data.customerInfo.issues));
        }
        setInputError(null);
        setTableData(data.referralEvents.referrals);
        setBeneficiariesData(data.beneficiaryData);
      })
      .catch((err) => {
        setInputError(err);
        setCancelSubCheckbox(false);
        setDeleteUserCheckbox(false);
      });
  };
  const tableColumns = [
    {
      Header: "Date",
      accessor: "date",
      disableSortBy: true,
    },
    {
      Header: "Email Address",
      accessor: "email_address",
    },
    {
      Header: "Status",
      accessor: "user_status",
    },
    {
      Header: "Reward",
      accessor: "reward",
      disableSortBy: true,
    },
    {
      Header: "Reward Status",
      accessor: "reward_status",
    },
    {
      Header: "Referral Code",
      accessor: "code",
    },
    {
      Header: "Referral Method",
      accessor: "method",
    },
  ];
  const BeneficiariesColumns = [
    {
      Header: "Creation Date",
      accessor: "creation_date",
    },
    {
      Header: "Beneficiary Email",
      accessor: "email",
    },
    {
      Header: "Piority Level",
      accessor: "priority",
    },
    {
      Header: "Beneficiary Status",
      accessor: "status",
      disableSortBy: true,
    },
    {
      Header: "Last day to login",
      accessor: "last_day_login",
      disableSortBy: true,
    },
  ];

  const sorterTableData = useMemo(() => {
    if (!tableData) return;
    let sorted = tableData.map((referral) => {
      let user_status;
      let reward_status;
      let reward;
      if (referral.reward.money && referral.reward.time) {
        reward = `${Math.round(
          referral.reward.time / 2629746000
        )} ${"Months Subscription"} & ${referral.reward.money} euros`;
      } else if (referral.reward.time) {
        reward = `${Math.round(
          referral.reward.time / 2629746000
        )} Months Subscription`;
      } else if (referral.reward.money) {
        reward = `${referral.reward.money} euros`;
      } else reward = null;

      if (referral.status.customer_status === "invitation")
        user_status = "Invited";
      else if (referral.status.customer_status === "trial")
        user_status = "Trial Account";
      else if (referral.status.customer_status === "subscription")
        user_status = "Subscribed";
      else if (referral.status.customer_status === "cancelation")
        user_status = "Customer in Cancelation Period";
      else user_status = "Invited";

      if (referral.reward_status === "done")
        reward_status = `Your Subscription Got Extended!`;
      else if (referral.reward_status === "none")
        reward_status = "Not Eligible";
      else if (referral.reward_status === "unclaimed")
        reward_status = "Unclaimed";
      else reward_status = "Not Eligible";

      return {
        date: dayjs(referral.date).format("YYYY-MM-DD"),
        email_address: referral?.customer_email,
        user_status,
        can_resend: referral.status?.can_resend,
        reward_status,
        reward,
        code: referral?.code,
        method: referral?.method,
        id: referral?.id,
      };
    });
    if (referral) {
      sorted = sorted.filter((item) => item.user_status === referral);
    }

    if (ben) {
      sorted = sorted.filter((item) => item.reward_status === ben);
    }

    return sorted;
  }, [data, referral, ben, tableData]);

  const beneficiaryTableData = useMemo(() => {
    if (!beneficiariesData) return;
    let sorted = beneficiariesData.map((item) => {
      let status;
      let creationDate;
      let lastDayLogin;
      if (item.accessed) {
        status = "Has Logged";
      } else status = item.status;

      if (item.creation_date) {
        creationDate = dayjs(item.creation_date).format("YYYY-MM-DD");
      } else creationDate = "-";

      if (item.last_day_login) {
        lastDayLogin = dayjs(item.last_day_login).format("YYYY-MM-DD");
      } else lastDayLogin = "-";
      return {
        creation_date: creationDate,
        email: item.email,
        status,
        priority: item.priority,
        last_day_login: lastDayLogin,
        accessed: item.accessed,
      };
    });

    return sorted;
  }, [data, beneficiariesData]);

  const cancelSubscribtion = async () => {
    if (!data) return;

    await fetch(base_url + "admin/customer/cancel/subscription", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `user_id=${data.customerInfo.user_id}`,
      credentials: "include",
    })
      .then((res) => {
        console.log(res);
        success(
          "success",
          `Subscription canceled Successfully for the user  : ${data.customerInfo.user_id}`
        );
        setCancelSubCheckbox(false);
        setOpenCancelUserModal(false);
      })
      .catch((err) => {
        console.log(err);
        success(
          "error",
          `Susbcription was not canceled successfully, please try again `
        );
        setCancelSubCheckbox(false);
        setOpenCancelUserModal(false);
      });
  };
  const deleteCustomer = async () => {
    if (!data) return;

    await fetch(base_url + "admin/customer/delete", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `user_id=${data.customerInfo.user_id}`,
      credentials: "include",
    })
      .then((res) => {
        console.log(res);
        success(
          "success",
          `User: ${data.customerInfo.user_id} deleted successfully`
        );
        setDeleteUserCheckbox(false);
        setOpenDeleteUserModal(false);
      })
      .catch((err) => {
        console.log(err);
        setDeleteUserCheckbox(false);
        setOpenDeleteUserModal(false);
        success("error", `User wasn't delete successfully, please try again`);
      });
  };
  return (
    <div className={styles.main}>
      {contextHolder}
      {userIsAdmin && (
        <div
          style={{
            position: "relative",
            width: "100%",
          }}
        >
          <h3 className={styles.title}>Customers</h3>
          <div className={styles.exportButtonsContainer}>
            <Button className={styles.exportButton}>
              Export All Customer general details
            </Button>
            <Button className={styles.exportButton}>
              Export All Customer attention issues
            </Button>
          </div>
        </div>
      )}
      <div className={styles.upper_div}>
        <div className={styles.subtitle}>Search for Customer</div>
        <div className={styles.flexbox} style={{ gap: "16px" }}>
          <button
            disabled
            className={styles.greenbutton}
            style={{ visibility: "hidden" }}
          >
            Send Code
          </button>
          <input
            value={userid}
            onChange={(e) => {
              setUserID(e.target.value.trim());
              setUserEmail("");
              setEmailOTP("");
            }}
            className={styles.user_input_div}
            placeholder="User ID"
          ></input>
          <input
            value={otp_code}
            onChange={(e) => {
              setOTP(e.target.value.trim());
              setEmailOTP("");
              setUserEmail("");
            }}
            className={styles.user_input_div_code}
            maxLength="8"
            placeholder="Code"
          ></input>

          <div onClick={verifyCustomer} className={styles.greenbutton}>
            Verify Customer
          </div>
          <button disabled onClick={sendCode} className={styles.greenbutton}>
            Send Code
          </button>
        </div>
        {userIsAdmin && (
          <div className={styles.flexbox} style={{ gap: "16px" }}>
            <button
              disabled
              className={styles.greenbutton}
              style={{ visibility: "hidden" }}
            >
              Send Code
            </button>

            <input
              onChange={(e) => {
                setUserEmail(e.target.value.trim());
                setUserID("");
                setOTP("");
              }}
              className={styles.user_input_div}
              placeholder="Email address"
              value={userEmail}
            ></input>
            <input
              value={email_otp_code}
              onChange={(e) => {
                setEmailOTP(e.target.value.trim());
                setOTP("");
                setUserID("");
              }}
              className={styles.user_input_div_code}
              maxLength="8"
              placeholder="Code"
            ></input>

            <div onClick={verifyCustomerEmail} className={styles.greenbutton}>
              Verify Customer
            </div>
            <button
              disabled
              onClick={sendCodeForEmail}
              className={styles.greenbutton}
            >
              Send Code
            </button>
          </div>
        )}
        {inputError ? <div>{inputError}</div> : null}
      </div>

      {data && (
        <div className={styles.container}>
          <div className={styles.firstRow}>
            <h3 className={styles.firstRowTitle}>General Details</h3>
            <div className={styles.firstRowContainer}>
              <div className={styles.firstRowContainer_col1}>
                <div className={styles.rowItemContainer}>
                  <p>User Id</p>
                  <p>{data?.customerInfo?.user_id}</p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>User Creation Date</p>
                  <p>
                    {data &&
                      dayjs(data?.customerInfo?.registration_date).format(
                        "YYYY-MM-DD"
                      )}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>User Status</p>
                  <p>{data?.customerInfo?.status}</p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>User Status Change Date</p>
                  <p>2023-06-23</p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Status Changed By</p>
                  <p>Tomer OHAYON</p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Subscription Plan</p>
                  <p>{data?.customerInfo?.subscription_plan}</p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Subscription Plan Start</p>
                  <p>
                    {data &&
                      data?.customerInfo?.subscription_plan_start !== null &&
                      dayjs(data?.customerInfo?.subscription_plan_start).format(
                        "YYYY-MM-DD"
                      )}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Subscription Plan End</p>
                  <p>
                    {data &&
                      dayjs(data?.customerInfo?.subscription_plan_end).format(
                        "YYYY-MM-DD"
                      )}
                  </p>
                </div>
              </div>
              <div className={styles.firstRowContainer_col2}>
                <div className={styles.rowItemContainer}>
                  <p>Last Login</p>
                  <p>
                    {data &&
                      dayjs(data?.customerInfo?.last_login).format(
                        "YYYY-MM-DD"
                      )}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Inheritance Mechanism Status:</p>
                  <p>{data?.customerInfo?.inheritance_status}</p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Notifications Method</p>
                  <p>{data?.customerInfo?.notification_method}</p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Notifications Frequency</p>
                  <p>
                    {data &&
                      formatTime(data?.customerInfo?.notification_frequency)}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Next notification date</p>
                  <p>
                    {data &&
                      dayjs(data?.customerInfo?.next_notification_date).format(
                        "YYYY-MM-DD"
                      )}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>2FA - Authentication app</p>
                  <p>
                    {data?.customerInfo?.mfa_authenticator ? (
                      <span>Active</span>
                    ) : (
                      <span>Inactive</span>
                    )}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>2FA - Yubikey</p>
                  <p>
                    {data?.customerInfo?.mfa_yubikey ? (
                      <span>Active</span>
                    ) : (
                      <span>Inactive</span>
                    )}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>User copied recovery key</p>
                  <p>
                    {data?.customerInfo?.recovery_key_copied ? (
                      <span>Yes</span>
                    ) : (
                      <span>No</span>
                    )}
                  </p>
                </div>
              </div>
              <div className={styles.firstRowContainer_col3}>
                <div className={styles.rowItemContainer}>
                  <p>Priority 1 will receive access at</p>
                  <p>
                    {data &&
                      dayjs(data?.customerInfo?.priority_one_access).format(
                        "YYYY-MM-DD"
                      )}
                  </p>
                </div>
                {/* <div className={styles.rowItemContainer}>
                  <p>User Id</p>
                  <p>{data?.customerInfo?.user_id}</p>
                </div> */}
                <div className={styles.rowItemContainer}>
                  <p>Priority 1 delay period</p>
                  <p>
                    {data && formatTime(data?.customerInfo?.priority_one_delay)}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Priority 2 will receive access at</p>
                  <p>
                    {data &&
                      dayjs(data?.customerInfo?.priority_two_access).format(
                        "YYYY-MM-DD"
                      )}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Priority 2 delay period</p>
                  <p>
                    {data && formatTime(data?.customerInfo?.priority_two_delay)}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Self Recovery Option activated</p>
                  <p>
                    {data?.customerInfo?.self_recovery_activated ? (
                      <span>Yes</span>
                    ) : (
                      <span>No</span>
                    )}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Self Recovery Delay</p>
                  <p>
                    {data &&
                      formatTime(data?.customerInfo?.self_recovery_delay)}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Subscribed to Newsletter?</p>
                  <p>
                    {data?.customerInfo?.subscribed_newsletter ? (
                      <span>Yes</span>
                    ) : (
                      <span>No</span>
                    )}
                  </p>
                </div>
                <div className={styles.rowItemContainer}>
                  <p>Phone number</p>
                  {/*
                    A dash when there is none: the field is optional, and an
                    empty value here reads as a panel that failed to load.

                    Shown as "(+33)-612345678" rather than the stored
                    "33612345678" -- see Utils/formatPhone. Stored numbers run
                    the country code straight into the rest with no separator,
                    which is unreadable at a glance.
                  */}
                  <p>{formatPhone(data?.customerInfo?.phone_number) || "-"}</p>
                </div>
              </div>
            </div>
            <h3 className={styles.firstRowTitle}>Attention Issues</h3>
            <div className={styles.secondRowContainer}>
              {issues.length > 0 ? (
                issues.map((issue, i) => {
                  return (
                    <div key={i} className={styles.secondRowContainer_row}>
                      <span>{i + 1}-</span>
                      <span>{issue}</span>
                    </div>
                  );
                })
              ) : (
                <div className={styles.secondRowContainer_row}>
                  <p>No Issues Recorded</p>
                </div>
              )}
              {/* {data?.customerInfo?.issues.length > 0 ? (
                data?.customerInfo?.issues.map((issue, i) => {
                  return issue.map((issue, n) => {
                    return (
                      <div key={n} className={styles.secondRowContainer_row}>
                        <span>Issue type: {issue.type} </span>
                        <span>Issue ID: {issue.id}</span>
                      </div>
                    );
                  });
                  // return (
                  //   <div key={i} className={styles.secondRowContainer_row}>
                  //     <p>{i}.</p>
                  //     <p>issues</p>
                  //   </div>
                  // );
                })
              ) : (
                <div className={styles.secondRowContainer_row}>
                  <p>No Issues Recorded</p>
                </div>
              )} */}
              {/* <div className={styles.secondRowContainer_row}>
              <p>1.</p>
              <p>Issues 3 text</p>
            </div>
            <div className={styles.secondRowContainer_row}>
              <p>2.</p>
              <p>Issues 3 text</p>
            </div>
            <div className={styles.secondRowContainer_row}>
              <p>3.</p>
              <p>Issues 3 text</p>
            </div> */}
            </div>
            <div
              style={{
                borderBottom: "1px solid #0091ea",
              }}
            >
              <h3 className={styles.firstRowTitle}>Referral program</h3>
              <div className={styles.thirdRowContainer}>
                <p className={styles.thirdRowContainer_link}>
                  Personal referral link:&nbsp;
                  <span>{data.referralLink}</span>
                </p>
                <p
                  style={{
                    fontWeight: "600",
                    fontSize: "16px",
                    marginTop: "40px",
                  }}
                >
                  Invited Contacts
                </p>
                <div
                  style={
                    {
                      // backgroundColor: "#F7F7F7",
                    }
                  }
                >
                  <TableFilter
                    component={"referral"}
                    filter={filter}
                    setFilter={setFilter}
                    setAsset={setReferral}
                    setBen={setBen}
                    customerStyle={"customer"}
                  />
                  <ReferralTable
                    customerStyle={"customer"}
                    columns={tableColumns}
                    data={sorterTableData}
                    filter={filter}
                    setFilter={setFilter}
                  />
                </div>
              </div>
            </div>
            {userIsAdmin && (
              <div
                style={{
                  borderBottom: "1px solid #0091ea",
                }}
              >
                <h3 className={styles.firstRowTitle}>
                  Beneficiaries information
                </h3>
                <div className={styles.thirdRowContainer}>
                  <div>
                    <TableFilter
                      component={"beneficiary"}
                      filter={filter}
                      setFilter={setBeneficiaryFilter}
                    />
                    <ReferralTable
                      component={"beneficiary"}
                      columns={BeneficiariesColumns}
                      data={beneficiaryTableData}
                      filter={beneficiaryFilter}
                      setFilter={setBeneficiaryFilter}
                    />
                  </div>
                </div>
              </div>
            )}
            {userIsAdmin && (
              <div className={styles.footerButtonsContainer}>
                <Modal
                  className={styles.cancelUserModal}
                  open={openCancelUserModal}
                  onCancel={(e) => {
                    setOpenCancelUserModal(false);
                  }}
                  footer={[
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        gap: "10px",
                      }}
                    >
                      <Button
                        onClick={(e) => {
                          setOpenCancelUserModal(false);
                        }}
                        className={styles.closeSubModalButton}
                      >
                        Close
                      </Button>
                      <Button
                        onClick={(e) => {
                          cancelSubscribtion();
                        }}
                        className={styles.cancelSubModalButton}
                      >
                        Cancel
                      </Button>
                    </div>,
                  ]}
                >
                  <div className={styles.modalContainer}>
                    <h2>
                      Are you sure you want to cancel user’s subscription?
                    </h2>
                  </div>
                </Modal>
                <div className={styles.cancelSub}>
                  <Checkbox
                    checked={cancelSubCheckbox}
                    onChange={(e) => {
                      setCancelSubCheckbox(e.target.checked);
                    }}
                  >
                    Confirm you wish to cancel subscription (this is not
                    reimboursing or refunding the customer)
                  </Checkbox>
                  <Button
                    disabled={!cancelSubCheckbox ? true : false}
                    onClick={(e) => {
                      setOpenCancelUserModal(true);
                    }}
                    className={styles.cancelSubButton}
                  >
                    Cancel subscription
                  </Button>
                </div>
                <div className={styles.deleteUser}>
                  <Modal
                    className={styles.cancelUserModal}
                    open={openDeleteUserModal}
                    onCancel={(e) => {
                      setOpenDeleteUserModal(false);
                    }}
                    footer={[
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                          gap: "10px",
                        }}
                      >
                        <Button
                          onClick={(e) => {
                            setOpenDeleteUserModal(false);
                          }}
                          className={styles.closeSubModalButton}
                        >
                          Close
                        </Button>
                        <Button
                          onClick={(e) => {
                            deleteCustomer();
                          }}
                          className={styles.cancelSubModalButton}
                        >
                          Delete
                        </Button>
                      </div>,
                    ]}
                  >
                    <div className={styles.modalContainer}>
                      <h2>Are you sure you want to delete user?</h2>
                    </div>
                  </Modal>
                  <Checkbox
                    checked={deleteUserCheckbox}
                    onChange={(e) => {
                      setDeleteUserCheckbox(e.target.checked);
                    }}
                  >
                    Confirm you wish to delete user
                  </Checkbox>
                  <Button
                    onClick={(e) => {
                      setOpenDeleteUserModal(true);
                    }}
                    disabled={!deleteUserCheckbox ? true : false}
                    className={styles.deleteUserButton}
                  >
                    Delete User
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {/* <div className={styles.lower_div}>
                <div className={styles.data_container}>
                    <div className={styles.greenbutton} style={{position:"absolute", right:"220px", top:"0px"}}>Edit</div>
                    <div>User ID number: <input className={styles.data_text} value={data?data.customerInfo.user_id:null}></input></div>
                    <div>User Status: <input className={styles.data_text} value={data?data.customerInfo.status:null}></input></div>
                    <div>Subscription Plan: <input className={styles.data_text} value={data?data.customerInfo.plan:null}></input></div>
                    <div>Last Login: <input className={styles.data_text} value={data? formatDate(data.customerInfo.last_login):null}></input></div>
                    <div>Inheritance Mechanisem Status: <input className={styles.data_text} value={data?data.customerInfo.inheritance_status.toString():null}></input></div>
                    <div>Notify EP - EA request: <input className={styles.data_text} value={data?formatTime(data.customerInfo.keep_alive_timeout):null}></input></div>
                    <div>Notify EP - KA timeout: <input className={styles.data_text} value={data?formatTime(data.customerInfo.next_notification-Date.now()):null}></input></div>
                </div>
                <div className={styles.rect}/>
                <div className={styles.issues_div}>
                    Issues in the security mechanism:
                    <div className={styles.issues}>
                        {data
                        ?handleAdminIssues(data.customerInfo.issues).map(element=>{
                            // return element.map(e=>{
                            return <><div key = {Math.random()} className={styles.issues_cell}>{element}</div><div className={styles.rect} style={{width:"40%"}}/></>
                            // }) 
                        })
                        :null}
                    </div>
                </div>
                <div className={styles.issues_div}>
                    <div className={styles.view_div}>Issues in the security mechanism: <div className={styles.greentext} onClick={()=>setShowCodes(!showCodes)}>View {showCodes&&<div className={styles.error_message}>{data?data.beneficiaryCodes.error:null}</div>}</div></div>
                    <div className={styles.issues}>
                    {showCodes &&
                    (data
                        ?typeof(data.beneficiaryCodes.result)=="string"
                            ?null
                            :data.beneficiaryCodes.result.map(element=>{
                                return <><div className={styles.issues_cell}>{`${element.email}:${element.personal_code}` }</div><div className={styles.rect} style={{width:"40%"}}/></>
                            })
                        :null
                    )
                    }
                    </div>
                </div>
            </div> */}
    </div>
  );
}
export { Customers };
